import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import injectStyles from 'react-jss'

import { promisify } from 'Utils/Actions'
import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import { FiltersWrapper } from 'Components/Filter/FiltersWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import AddIcon from '@material-ui/icons/Add'
import SubmitButton from '../../../../../Components/Form/SubmitButton/index'
import { ModalConfirmation } from 'Components/Modal/ModalConfirmation'
import { SearchInput } from 'Components/Header/SearchInput'

import LocationEdit from 'Containers/City/Page/Locations/Modals/LocationEdit'
import LocationAdd from 'Containers/City/Page/Locations/Modals/LocationAdd'

import * as CONST from 'Reducers/Location/const'
import {
  archiveLocation,
  setLocationsByCityIdStatusFilter,
  getLocationTypes,
} from 'Reducers/Location/actions'

import LinkButtonWithText from 'Components/Buttons/LinkButtonWithText'
import BatchImportLocationForm from 'Containers/Form/City/Locations/BatchImport'
import { uploadFile } from 'Reducers/Upload/actions'
import { createJob } from 'Reducers/Jobs/actions'
import { escapeCsvString } from '../../../../../shared/csv'
import { downloadStringAsFile } from '../../../../../Utils/Misc'
import { LOCATION_SORT_COLUMN_ENUM } from '../../../../../shared/constants'
import LocationsTable from '../Components/LocationsTable'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'
import getLocationWithPagination from '../gql'
import Pagination from 'Components/FilterAndPaginationComponent/Pagination'
import { isDefined } from '../../../../../shared/libraries/utils/object'
import { styles } from './styles'

const resultsPerPage = 50
const formatLocations = (isLoaded, data) =>
  isLoaded ? data.city.locations.edges.map(el => el.node) : []

const LocationsContainer = props => {
  const [locationId, setLocationId] = useState(null)
  const [modalAddShow, setModalAddShow] = useState(false)
  const [importLocationsFile, setImportLocationsFile] = useState(null)
  const [offsetRecordsStart, setOffsetRecordsStart] = useState(0)
  const [searchString, setSearchString] = useState('')
  const [orderByColumn, setOrderByColumn] = useState('')
  const [reverse, setReverse] = useState(false)
  const [status, setStatus] = useState(null)
  const dispatch = useDispatch()

  const [modalArchiveShow, setModalArchiveShow] = useState(false)
  const [modalEditShow, setModalEditShow] = useState(false)
  const [modalImportLocationShow, setModalImportLocationShow] = useState(false)
  const { data, isLoaded, refetch } = useGraphQLFetch({
    skipFetchOnInit: true,
    fetchFn: getLocationWithPagination,
  })

  const onOffsetChange = offset => {
    if (offset < 0) offset = 0
    if (offset > totalCount) return

    setOffsetRecordsStart(offset)
  }

  const calculatedTypeIds =
    props.locationTypeOptions.length > 0
      ? props.locationTypeOptions.reduce((acc, location) => {
          if (location.value != 25) {
            acc.push(Number(location.value))
          }
          return acc
        }, [])
      : undefined
  const onChangeStatusHandler = (e, index, value) => setStatus(value)

  const searchHandler = searchString => setSearchString(searchString)

  const handleModalAddShow = () => setModalAddShow(true)

  const handleModalAddCancel = () => setModalAddShow(false)

  const handleModalAddSubmitSuccess = () => {
    fetchLocations()
    setModalAddShow(false)
  }

  const handleModalEditShow = useCallback(locationId => {
    setModalEditShow(true)
    setLocationId(locationId)
  }, [])

  const handleModalEditCancel = () => {
    setModalEditShow(false)
    setLocationId(null)
  }

  const handleModalEditSuccess = () => {
    fetchLocations()

    setModalEditShow(false)
    setLocationId(null)
  }

  const handleModalArchiveShow = useCallback(locationId => {
    setModalArchiveShow(true)
    setLocationId(locationId)
  }, [])
  const handleModalImportLocationShow = () => setModalImportLocationShow(true)

  const handleModalArchiveCancel = () => {
    setModalArchiveShow(false)
    setLocationId(null)
  }

  const handleModalImportLocationsCancel = () =>
    setModalImportLocationShow(false)

  const handleModalArchiveConfirm = () => {
    const callbacks = {
      onSuccess: fetchLocations,
    }

    setModalArchiveShow(false)
    setLocationId(null)

    dispatch(archiveLocation(callbacks, locationId))
  }

  const handleModalImportLocationsConfirm = async () => {
    const uploadFileAsync = promisify((file, callbacks) =>
      dispatch(uploadFile(file, callbacks, 'text/csv')),
    )
    const createJobAsync = promisify((...args) => dispatch(createJob(...args)))

    const fileUrl = await uploadFileAsync(importLocationsFile)

    await createJobAsync({
      type: 'import-locations',
      fileUrl,
    })
    setModalImportLocationShow(false)
    fetchLocations()
  }
  const currentColumnSort = column => {
    switch (column) {
      case 'name':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.NAME_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.NAME_ASC
        }
      case 'label':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.LABEL_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.LABEL_ASC
        }
      case 'type':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.TYPE_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.TYPE_ASC
        }
      case 'momentsMorning':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_MORNING_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_MORNING_ASC
        }
      case 'momentsLunch':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_LUNCH_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_LUNCH_ASC
        }
      case 'momentsAfternoon':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_AFTERNOON_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_AFTERNOON_ASC
        }
      case 'isSheltered':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_SHELTERED_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_SHELTERED_ASC
        }
      case 'isEvent':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_EVENT_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_EVENT_ASC
        }
      case 'requirePermit':
        setReverse(false)
        if (reverse) {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_REQUIRE_PERMIT_DESC
        } else {
          setReverse(!reverse)
          return LOCATION_SORT_COLUMN_ENUM.IS_REQUIRE_PERMIT_ASC
        }
    }
  }

  const changeSort = useCallback(
    columnName => setOrderByColumn(currentColumnSort(columnName)),
    [],
  )
  const fetchLocations = () => {
    if (orderByColumn) {
      refetch({
        cityId: props.cityId,
        typeIds: props.isDM ? [25] : calculatedTypeIds,
        orderBy: orderByColumn,
        status,
        name: searchString,
        offset: offsetRecordsStart,
        first: resultsPerPage,
      })
    } else {
      refetch({
        cityId: props.cityId,
        typeIds: props.isDM ? [25] : calculatedTypeIds,
        status,
        name: searchString,
        offset: offsetRecordsStart,
        first: resultsPerPage,
      })
    }
  }
  useEffect(() => {
    fetchLocations()
  }, [
    offsetRecordsStart,
    resultsPerPage,
    orderByColumn,
    status,
    searchString,
    modalAddShow,
    props.isDM,
  ])

  let locations = useMemo(() => formatLocations(isLoaded, data), [
    data,
    props.cityId,
    offsetRecordsStart,
    resultsPerPage,
    searchString,
    isLoaded,
  ])
  let totalCount = isLoaded ? data.city.locations.totalCount : 0
  const statusFilter = useSelector(
    state => state.locations.locationsByCityIdStatusFilter,
  )
  const searchValue = useSelector(
    state => state.locations.locationsByCityIdSearchValue,
  )

  useEffect(() => {
    if (statusFilter.value !== CONST.LOCATION_STATUS[0].value) {
      dispatch(setLocationsByCityIdStatusFilter(CONST.LOCATION_STATUS[0]))
    }

    dispatch(getLocationTypes())
  }, [])

  const onBatchImportLocationFileChange = files =>
    setImportLocationsFile(files[0])

  const onExportData = async () => {
    const response = await getLocationWithPagination({ cityId: props.cityId })
    const { data: dataExport } = await response.json()

    let exportLocations = formatLocations(true, dataExport)

    const exportHeaders = [
      'Name',
      'Type',
      'City',
      'Latitude',
      'Longitude',
      'qa_morning',
      'qa_lunch',
      'qa_afternoon',
      'qa_weekend_morning',
      'qa_weekend_afternoon',
      'Sheltered',
      'Has Permit',
    ]

    let content = exportHeaders.join(',')
    exportLocations.forEach(location => {
      if (location.status !== 'ENABLED') return
      const rowData = {
        'Name': location.name,
        'Type': location.type.name,
        'City': props.cityName,
        'Latitude': location.latitude,
        'Longitude': location.longitude,
        'qa_morning': location.moments.morning ? 'x' : '',
        'qa_lunch': location.moments.lunch ? 'x' : '',
        'qa_afternoon': location.moments.afternoon ? 'x' : '',
        'qa_weekend_morning': location.moments.morning ? 'x' : '',
        'qa_weekend_afternoon': location.moments.afternoon ? 'x' : '',
        'Sheltered': location.isSheltered ? 'x' : '',
        'Has Permit': location.hasPermit ? 'x' : '',
      }
      content +=
        '\n' +
        exportHeaders
          .map(headerName => {
            const value = rowData[headerName]
            return typeof value === 'string' ? escapeCsvString(value) : value
          })
          .join(',')
    })
    downloadStringAsFile(
      content,
      `city_${props.cityName}_locations.csv`,
      'text/csv',
    )
  }

  return (
    <div>
      <LayoutDashboard>
        <FiltersWrapper className="filters-wrapper">
          <FilterBox className="filter-box">
            <SearchInput
              className="search-input"
              placeholder="Search anything"
              searchHandler={searchHandler}
              value={searchValue}
            />
          </FilterBox>
          <FilterBox className="filter-box">
            <FilterSelect
              className="select-status"
              hasPrimaryText={false}
              label="Status"
              onChange={onChangeStatusHandler}
              options={CONST.LOCATION_STATUS}
              value={status}
              sorted={true}
            />
            <LinkButtonWithText
              target="_blank"
              className="locations-import-button"
              label="Import"
              title="Import locations from a spreadsheet"
              onClick={handleModalImportLocationShow}
            />
            <LinkButtonWithText
              className="locations-import-button"
              label="Export"
              title="Export locations"
              onClick={onExportData}
            />
            <SubmitButton
              className="add-button-link"
              onClick={handleModalAddShow}
              startIcon={<AddIcon />}
            />
          </FilterBox>
        </FiltersWrapper>
      </LayoutDashboard>
      <div className={props.classes.tableWrapper}>
        <LocationsTable
          locations={locations}
          changeSort={changeSort}
          handleModalArchiveShow={handleModalArchiveShow}
          handleModalEditShow={handleModalEditShow}
        />
      </div>
      <Pagination
        total={isDefined(totalCount) ? totalCount : locations.length}
        offset={isDefined(offsetRecordsStart) ? offsetRecordsStart : 0}
        resultsPerPage={
          isDefined(resultsPerPage) ? resultsPerPage : locations.length
        }
        onOffsetChange={onOffsetChange}
      />
      {modalEditShow && (
        <LocationEdit
          handleCancel={handleModalEditCancel}
          handleSuccess={handleModalEditSuccess}
          locationTypeOptions={props.locationTypeOptions}
          locationId={locationId}
          modalShow={true}
        />
      )}
      <LocationAdd
        handleCancel={handleModalAddCancel}
        handleSuccess={handleModalAddSubmitSuccess}
        locationTypeOptions={props.locationTypeOptions}
        modalShow={modalAddShow}
        city={{ id: props.cityId }}
      />
      <ModalConfirmation
        handleCancel={handleModalArchiveCancel}
        handleConfirm={handleModalArchiveConfirm}
        modalShow={modalArchiveShow}
        text="Are you sure you want to archive this location?"
      />
      <ModalConfirmation
        title="Import locations"
        handleCancel={handleModalImportLocationsCancel}
        handleConfirm={handleModalImportLocationsConfirm}
        modalShow={modalImportLocationShow}
        text={
          <div>
            <BatchImportLocationForm
              onChange={onBatchImportLocationFileChange}
            />
          </div>
        }
      />
    </div>
  )
}
export default injectStyles(styles)(LocationsContainer)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Locations/Container/LocationsContainer.js